"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionNoteStatusBadge = void 0;
var _react = _interopRequireDefault(require("react"));
var _types = require("../types");
var _components = require("../components");
var _StatusBadgeProps;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StatusBadgeProps = (_StatusBadgeProps = {}, _defineProperty(_StatusBadgeProps, _types.SessionNoteStatus.Draft, {
  type: 'warning',
  text: 'Not submitted'
}), _defineProperty(_StatusBadgeProps, _types.SessionNoteStatus.Submitted, {
  type: 'success',
  text: 'Submitted'
}), _defineProperty(_StatusBadgeProps, _types.SessionNoteStatus.Discarded, {
  type: 'orange',
  text: 'Discarded'
}), _StatusBadgeProps);
var SessionNoteStatusBadge = function SessionNoteStatusBadge(_ref) {
  var status = _ref.status;
  var config = StatusBadgeProps[status];

  // Gracefully handle unknown/missing statuses
  if (!config) {
    console.warn("Unexpected session note status encountered: \"".concat(status, "\". Known statuses are: ").concat(Object.keys(StatusBadgeProps).join(', ')));
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
    type: config.type
  }, config.text);
};
exports.SessionNoteStatusBadge = SessionNoteStatusBadge;